module.exports = __webpack_public_path__ + "img/4.a7b6668f.png";